import {schemaTypes} from '../../../constants/constants';


const schema = {
    key:"tripwise_report",
    name:"Trip wise Report",
    toolbar:[
    ],
    content:[
        {
            key:"tripwise_report",
            name:"Trip wise Report",
            type:schemaTypes.TRIP_WISE_REPORT,
            position:{
                width:12,
                height:12,
                left:0,
                top:0
            },
        }
    ]
}
export default schema;